import { z } from "zod";

export const signInSchema = z.object({
    email: z.string().email("Invalid email format"),
    password: z.string().min(8, "Password is not valid")
    // .regex(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}$/)
    // .regex(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}$/, "Password is not valid")
});

export type SignInFormData = z.infer<typeof signInSchema>;

export const forgotPasswordSchema = z.object({
    email: z.string().email("Invalid email format")
});

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
    .object({
        email: z.string().email("Invalid email format"),
        token: z.string().min(1, "Token is required"),
        newPassword: z
            .string()
            .min(8, "Password must be at least 8 characters")
            .regex(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}$/,
                "Password must include uppercase, lowercase, number, and special character"
            ),
        confirmPassword: z.string()
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
        message: "Passwords do not match",
        path: ["confirmPassword"]
    });

export type ResetPassword = z.infer<typeof resetPasswordSchema>;

// For a first-time login using temporary creds:
export const firstTimeSignInSchema = z
    .object({
        email: z.string().email("Invalid email format"),
        tempPassword: z.string().min(1, "Temporary password is required"),
        newPassword: z
            .string()
            .min(8, "New password must be at least 8 characters")
            .regex(
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}$/,
                "New password must include uppercase, lowercase, number, and special character"
            ),
        confirmNewPassword: z.string().min(1, "Confirm new password is required")
    })
    .refine((data) => data.newPassword === data.confirmNewPassword, {
        message: "Passwords do not match",
        path: ["confirmNewPassword"]
    });

export type FirstTimeSignInFormData = z.infer<typeof firstTimeSignInSchema>;
